import { useState } from "react";
import { type EditorOps } from "./editorCore";

export const useSaturacion = (
  ops: EditorOps,
  setOps: (ops: EditorOps) => void
) => {
  const [saturacion, setSaturacion] = useState(ops.saturacion ?? 0);

  const handleChange = (value: number) => {
    setSaturacion(value);
    setOps({ ...ops, saturacion: value });
  };

  const reset = () => {
    setSaturacion(0);
    setOps({ ...ops, saturacion: undefined });
  };

  const control = (
    <div>
      <label>Saturación</label>
      <input
        type="range"
        min={-100}
        max={100}
        value={saturacion}
        onChange={(e) => handleChange(+e.target.value)}
      />
      <button className="btn btn-default" onClick={reset}>
        Reset
      </button>
    </div>
  );

  return {
    control,
    onMouseDown: undefined,
    onMouseMove: undefined,
    onMouseUp: undefined,
    renderOverlay: undefined,
  };
};
